interface DropdownStringMandatoryProps {
  listInputs: string[];
  label: string;
  inputName: string;
  value: string;
  handleOnChange(e: any): void;
  invalidValues?: string[];
  editableTitle? : JSX.Element;
}

function DropdownStringMandatory({
  listInputs,
  label,
  value,
  handleOnChange,
  inputName,
  invalidValues = [],
  editableTitle
}: DropdownStringMandatoryProps) {
  return (
    <div className="form-group">
        {editableTitle?<label className="control-label">{editableTitle}</label>:<label className="control-label">{label}</label>}
      <select
        className={
          invalidValues.includes(value)
            ? "form-control is-invalid"
            : "form-control "
        }
        name={inputName}
        value={value}
        onChange={handleOnChange}
      >
        {listInputs.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}
export default DropdownStringMandatory;
